// extracted by mini-css-extract-plugin
export default {"tablerow":"OfficialCard_tablerow__S+DBw"};